<template>
    <v-container>
      <v-row class="elevation-1">
        <v-col cols="6" lg="12">
          <v-btn
            id="create-new-fiscal-year"
            class="mx-2" color="primary"
            @click="openDialogbox"
          >
            Create New Fiscal Year
          </v-btn>
          <OdCreateFiscalYearOd
            :dialog="dialog"
            @dialogVal="setDialog"
          />
        </v-col>
      </v-row>
    </v-container>
  </template>
<script>

import OdCreateFiscalYearOd from '../../../components/OD/OdCreateFiscalYearOd.vue';

export default {
  name: 'OdCreateFiscalYear',
  components: {
    OdCreateFiscalYearOd,
  },
  data: () => ({
    dialog: false,
  }),
  created() {},
  computed: {
  },
  methods: {
    openDialogbox() {
      this.dialog = true;
    },
    setDialog(val) {
      this.dialog = val;
    },
  },
};
</script>
